export default "__VITE_ASSET__laPQG2T3__"